module.exports = __webpack_public_path__ + "static/media/pflogo.ab872b95.png";